import React, { Component } from 'react'

export default class HPHid extends Component {
  render() {
    const { formikField } = this.props

    return (
      <input
        className="hidden"
        type="text"
        {...formikField} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/HPHid.js